import {useState, useEffect} from "react";

export const useActiveSection = (sectionIds = [], rootMargin = "-20% 0px -60% 0px") => {
    const [activeSection, setActiveSection] = useState("");

    const sectionIdsKey = Array.isArray(sectionIds) ? sectionIds.join(",") : "";

    useEffect(() => {
        if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
            return;
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveSection(entry.target.id);
                    }
                });
            },
            {
                rootMargin,
                threshold: 0.1,
            }
        );

        const ids = sectionIdsKey ? sectionIdsKey.split(",") : [];
        const observedElements = [];
        ids.forEach((id) => {
            const el = document.getElementById(id);
            if (el) {
                observer.observe(el);
                observedElements.push(el);
            }
        });

        return () => {
            observedElements.forEach((el) => observer.unobserve(el));
            observer.disconnect();
        };
    }, [sectionIdsKey, rootMargin]);

    return activeSection;
};
